import { ChequeGiroModel } from 'api-hooks/cheque-giro';
import React from 'react';

import { ChequeGiroFormType } from '../components/form-type';

export default function useChequeGiroDefaultValues(
  chequeGiro?: ChequeGiroModel,
): ChequeGiroFormType {
  const defaultValues = React.useMemo<ChequeGiroFormType>(() => {
    return {
      bankCode: chequeGiro?.bankCode || '',
      isActive: chequeGiro?.isActive ?? false,
      name: chequeGiro?.name || '',
      chequeGiro,
    };
  }, [chequeGiro]);
  return defaultValues;
}
